import { useEffect, useState } from 'react';
import { apiRequest, apiUpload } from '@/lib/api/client';
import { Resources } from '@/features/doctoral/components/DoctoralResources';
import type { Resource } from '@/features/doctoral/workflowApi';
import { useAdvisorText as useStudyText } from '../labels';
interface Edition {
  id: string;
  title: string;
  revision: string;
  status: string;
  source: string;
}
export function AdvisorResources() {
  const st = useStudyText();
  const [items, setItems] = useState<Resource[]>([]);
  const [editions, setEditions] = useState<Edition[]>([]);
  const [publish, setPublish] = useState(false);
  const [resource, setResource] = useState('');
  const [revision, setRevision] = useState('');
  const [source, setSource] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const refresh = () =>
    apiRequest<{ items: Resource[]; editions: Edition[]; can_publish: boolean }>(
      '/advisor/resources',
      { channel: 'platform' },
    ).then((p) => {
      setItems(p.items);
      setEditions(p.editions);
      setPublish(p.can_publish);
    });
  useEffect(() => {
    let cancelled = false;
    apiRequest<{ items: Resource[]; editions: Edition[]; can_publish: boolean }>(
      '/advisor/resources',
      { channel: 'platform' },
    )
      .then((p) => {
        if (!cancelled) {
          setItems(p.items);
          setEditions(p.editions);
          setPublish(p.can_publish);
        }
      })
      .catch((e) => {
        if (!cancelled) setError(String(e.message));
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <section className="advisor-monitor-panel">
      <div className="advisor-monitor-body">
        <h3>{st('Утверждённые инструкции и образцы')}</h3>
        {error && <p role="alert">{error}</p>}
        <div
          className="dp120-root"
          style={{ position: 'static', inset: 'auto', zIndex: 'auto', overflow: 'visible' }}
        >
          <Resources resources={items} />
        </div>
        <h3>{st('Новая редакция образца')}</h3>
        <p>
          {st(publish ? 'Редакция будет опубликована.' : 'Редакция будет передана на утверждение.')}
        </p>
        <div className="advisor-monitor-filters">
          <label className="advisor-monitor-field">
            <span>{st('Образец')}</span>
            <select value={resource} onChange={(e) => setResource(e.target.value)}>
              <option value="">{st('Выберите…')}</option>
              {items.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.title}
                </option>
              ))}
            </select>
          </label>
          <label className="advisor-monitor-field">
            <span>{st('Редакция')}</span>
            <input value={revision} onChange={(e) => setRevision(e.target.value)} maxLength={100} />
          </label>
          <label className="advisor-monitor-field">
            <span>{st('Источник утверждения')}</span>
            <input value={source} onChange={(e) => setSource(e.target.value)} maxLength={1000} />
          </label>
          <input
            type="file"
            aria-label={st('Файл образца')}
            disabled={busy || !resource || !revision.trim() || !source.trim()}
            onChange={(e) => {
              const file = e.target.files?.[0];
              e.target.value = '';
              if (!file) return;
              setBusy(true);
              setError('');
              void apiUpload(`/advisor/resources/${encodeURIComponent(resource)}`, file, 'file', {
                revision,
                source,
              })
                .then(refresh)
                .catch((e) => setError(String(e.message)))
                .finally(() => setBusy(false));
            }}
          />
        </div>
        <h3>{st('История редакций')}</h3>
        {editions.map((e) => (
          <p key={e.id}>
            {e.title} · {e.revision} · {st(e.status)} · {e.source}{' '}
            {publish && e.status === 'DRAFT' && (
              <button
                className="advisor-monitor-mini"
                disabled={busy}
                onClick={() => {
                  setBusy(true);
                  void apiRequest(`/advisor/resources/editions/${e.id}/approve`, {
                    channel: 'platform',
                    method: 'POST',
                  })
                    .then(refresh)
                    .catch((e) => setError(String(e.message)))
                    .finally(() => setBusy(false));
                }}
              >
                {st('Утвердить')}
              </button>
            )}
          </p>
        ))}
      </div>
    </section>
  );
}
